<template>
  <div class="rm-screen">
    <div v-if="loading" class="rm-empty">
      <v-progress-circular indeterminate color="#c2410c"></v-progress-circular>
    </div>
    <div v-else-if="!hasRows" class="rm-empty">
      <v-icon size="40" color="#8a817a">mdi-cash-off</v-icon>
      {{ $t("no_data") }}
    </div>

    <template v-else>
      <div class="rm-stats">
        <div v-for="(stat, index) in kpis" :key="stat.key" class="rm-stat" :class="{ 'rm-stat--inverse': index === 0 }">
          <span class="rm-stat__label">{{ stat.label }}{{ stat.key === "amount" ? currencySuffix : "" }}</span>
          <span class="rm-stat__value rm-num">{{ stat.value }}</span>
        </div>
      </div>

      <div class="rm-chip-row gm-chips">
        <button
          type="button"
          class="rm-chip"
          :class="{ 'rm-chip--active': groupByEmployee }"
          :aria-pressed="String(groupByEmployee)"
          @click="groupByEmployee = !groupByEmployee"
        >
          {{ $t("group_by_employee") }}
        </button>
      </div>

      <ul class="rm-list rm-card">
        <template v-if="groupByEmployee">
          <li v-for="row in groupedRows" :key="row.key" class="gm-user">
            <div class="gm-user__btn">
              <span class="gm-user__text">
                <span class="gm-user__name">{{ row.name }}</span>
                <span class="gm-user__meta rm-num">{{ $t("count") }} {{ row.count }}</span>
              </span>
              <span class="cmm-money rm-num">{{ money(row.amount) }}</span>
            </div>
          </li>
        </template>
        <template v-else>
          <li v-for="row in shownTopups" :key="row.key" class="gm-user">
            <div class="gm-user__btn">
              <span class="gm-user__text">
                <span class="gm-user__name">{{ row.name }}</span>
                <span class="gm-user__meta rm-num">{{ row.dateText }} · {{ row.restaurantText }}</span>
              </span>
              <span class="cmm-money rm-num">{{ money(row.amount) }}</span>
            </div>
          </li>
        </template>
      </ul>
      <button
        v-if="!groupByEmployee && hiddenCount > 0"
        type="button"
        class="rm-text-btn gm-user__more"
        @click="expanded = true"
      >
        {{ $t("report_mobile.show_all_n", { n: topups.length }) }}
      </button>
    </template>
  </div>
</template>

<script>
import CompanyDesktopMultiCreditTopups from "@/components/company-report/desktop/screens/multi/CompanyDesktopMultiCreditTopups.vue";
import "@/components/report/mobile/screens/group/groupMobileUsers.scss";
import hasMultiMobile from "../../hasMultiMobile";

const PAGE_SIZE = 25;

/**
 * Mobilni "Dopune kredita" firme "više restorana": svaka dopuna (radnik, datum, restoran, iznos) ili, uz "Grupiši po
 * radniku", broj dopuna i zbir po radniku. Period je u zaglavlju. Računa kao ekran za računar.
 */
export default {
  name: "CompanyMobileMultiCreditTopups",
  extends: CompanyDesktopMultiCreditTopups,
  mixins: [hasMultiMobile],
  data: () => ({
    expanded: false,
  }),
  computed: {
    shownTopups() {
      return this.expanded ? this.topups : this.topups.slice(0, PAGE_SIZE);
    },
    hiddenCount() {
      return this.topups.length - this.shownTopups.length;
    },
  },
};
</script>
